<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [gridName]="gridName"
    [multiSelect]="false"
    (refreshDataFromServer)="refreshData()"
   (rowSelected)="onRowClick($event)"
></app-grid>


